export interface HomeSlide {
  image: string;
  srcset: string;
  alt: string;
  /** Revolution Slider Ken Burns origin. */
  kenBurns: 'center' | 'right';
}

export const HOME_SLIDES: HomeSlide[] = [
  {
    image: '/basel/media/slider/Slider-1-1536x728.png',
    srcset:
      '/basel/media/slider/Slider-1-1200x568.png 1200w, /basel/media/slider/Slider-1-1536x728.png 1536w, /basel/media/slider/Slider-1.png 1900w',
    alt: 'Diffuser Dreams home slider 1',
    kenBurns: 'center'
  },
  {
    image: '/basel/media/slider/Slider-2-1536x728.png',
    srcset: '/basel/media/slider/Slider-2-1200x568.png 1200w, /basel/media/slider/Slider-2-1536x728.png 1536w',
    alt: 'Diffuser Dreams home slider 2',
    kenBurns: 'center'
  },
  {
    image: '/basel/media/slider/Slider-3-1536x728.png',
    srcset: '/basel/media/slider/Slider-3-1200x568.png 1200w, /basel/media/slider/Slider-3-1536x728.png 1536w',
    alt: 'Diffuser Dreams home slider 3',
    kenBurns: 'right'
  }
];

/** Featured products order from WP home-base (date ASC, first page of 8). */
export const FEATURED_SLUGS = [
  'moonlight-melody',
  'aurora-dream',
  'blissful-breeze',
  'enchanted-bloom',
  'celestial-harmony',
  'dream-tower-700-mini-1',
  'magic-1700-hc-a300',
  'mini-tower-100-hc-08x',
  'magic-1200-hc-300hf',
  'dream-tower-500-hc-1202',
  'luxury-tower-hc-a2000',
  'magic-3000-b-hc-a1000'
];

export const FEATURED_PAGE_SIZE = 8;
